// Copyright (c) 2019 Deere & Company

import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';
// import { getUserIdFromSessionStorage } from '../../shared/services/user-service';

const basePath = getBasePath();

export async function getSearchedClaimData ( searchedData ) {
    // let loggedInUserId = getUserIdFromSessionStorage()

    // const endPoint = `${basePath}/claims/search`;
    const endPoint = `${basePath}/claims/search`;
    

    const options = {
        body: JSON.stringify( searchedData ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getSearchedNonDeereClaimData ( searchedData ) {
    // let loggedInUserId = getUserIdFromSessionStorage()
    //${this.state.factoryType.toLowerCase()}"
    console.log("searchedData ",searchedData.factoryCode);
    // const endPoint = `${basePath}/claims/search`;
    let  endPoint = "";
    if(searchedData.factoryCode == 'liebherr'){
     endPoint = `${basePath}/nondeere/${searchedData.factoryCode.toLowerCase()}/claims/search`;
    }
    if(searchedData.factoryCode == 'claas'){
     endPoint = `${basePath}/nondeere/${searchedData.factoryCode.toLowerCase()}/claims/search`;
    }
    

    const options = {
        body: JSON.stringify( searchedData ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getProductSubSeries ( factoryCode, seriesId ) {

    const endPoint = `${basePath}/product-subseries?factoryCode=${factoryCode}&productSeriesId=${seriesId}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getBaseCodes ( factoryCode, seriesId = 0, subSeriesId ) {

    let endPoint = `${basePath}/base-codes?productSeriesIds=${seriesId}&productSubSeriesIds=${subSeriesId}&factoryCode=${factoryCode}`;
    if ( subSeriesId === '' || subSeriesId === '-1' || subSeriesId === 0 ) endPoint = `${basePath}/base-codes?productSeriesIds=${seriesId}&factoryCode=${factoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

// export async function getFactoryData ( searchedData ) {

//     const endPoint = `${basePath}/factory-data-extract-report`;

//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };

//     try {

//         const response = await fetchService.fetch( endPoint, options );

//         return response;

//     } catch ( error ) {

//         return handleError( error );

//     }

// }

// export async function getDefaultData ( searchedData ) {

//     const endPoint = `${basePath}/default-report`;

//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };

//     try {

//         const response = await fetchService.fetch( endPoint, options );

//         return response;

//     } catch ( error ) {

//         return handleError( error );

//     }

// }

// export async function getAnalysisCommentsData ( searchedData ) {

//     const endPoint = `${basePath}/analysis-comments-report  `;

//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };

//     try {

//         const response = await fetchService.fetch( endPoint, options );

//         return response;

//     } catch ( error ) {

//         return handleError( error );

//     }

// }

// export async function getTextExtractData ( searchedData ) {

//     const endPoint = `${basePath}/text-extract-report  `;

//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };

//     try {

//         const response = await fetchService.fetch( endPoint, options );

//         return response;

//     } catch ( error ) {

//         return handleError( error );

//     }

// }

// export async function getEvidencePackageData ( searchedData ) {

//     const endPoint = `${basePath}/default-report`;

//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };

//     try {

//         const response = await fetchService.fetch( endPoint, options );

//         return response;

//     } catch ( error ) {

//         return handleError( error );

//     }

// }

export async function getFindClaimDownloadReports ( reportname, searchedData ) {

    let url;
    // let loggedInUserId = getUserIdFromSessionStorage();

    switch ( reportname ) {

    case 'default-report':
        url = `default-report`;
        break;
    case 'replacement-part-report':
        url = `replacement-part-report`;
        break;
    case 'factory-report':
        url = 'factory-data-extract-report';
        break;
    case 'text-extract-report':
        url = 'text-extract-report';
        break;
    case 'analysis-comments-report':
        url = 'analysis-comments-report';
        break;
    case 'non-deere-default-report':
     //   url = 'non-deere-default-report';
        url =   `non-deere-default-report/${searchedData.factoryCode.toLowerCase()}`;
        break;
    case 'claas-default-report':
        url =   `claas-default-report/${searchedData.factoryCode.toLowerCase()}`;
        break;
    default:
        break;

    }

    const endPoint = `${basePath}/${url}`;

    const options = {
        body: JSON.stringify( searchedData ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );

    }

}

export async function updateNonDeereClaimData ( factoryCode, claimData ) {

    const endPoint = `${basePath}/nondeere/${factoryCode.toLowerCase()}/claims/${claimData.id}`;

    const options = {
        body: JSON.stringify( claimData ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}



export async function downloadSampleReports ( reportname ) {

    let url;
    if(reportname == 'non-deere-claims-report-claas'){
        url = "sample/report/download/xlsx?fileName="+reportname;
    }
    else{
        url = "sample/report/download/csv?fileName="+reportname;
    }
    const endPoint = `${basePath}/${url}`;    
        try {
            const options = {
                method: 'GET'
            };
        const response = await fetchService.fetch( endPoint, options );

        return response;
    } catch ( error ) {

        return handleError( error );

    }

}
